module.exports = __webpack_public_path__ + "static/media/release-notes.62f80d7c.svg";